var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AElf from 'aelf-sdk';
import { CONTRACT_GET_DATA_ERROR, CONTRACT_METHOD_NAME, MANAGER_FORWARD_CALL } from '../constants/index.js';
import { getAElf, getRawTx, getTxResult } from './aelfBase.js';
import { timesDecimals } from '../calculate/index.js';
import BigNumber from 'bignumber.js';
import { aelfInstance } from './aelfInstance.js';
import { handleManagerForwardCall, getContractMethods } from '@portkey/contracts';
const CacheViewContracts = {};
export const getContract = (endPoint, contractAddress, wallet) => __awaiter(void 0, void 0, void 0, function* () {
    const key = endPoint + contractAddress;
    if (!CacheViewContracts[key]) {
        if (!wallet)
            wallet = AElf.wallet.createNewWallet();
        const aelf = getAElf(endPoint);
        const contract = yield aelf.chain.contractAt(contractAddress, wallet);
        CacheViewContracts[endPoint + contractAddress] = contract;
        return contract;
    }
    return CacheViewContracts[key];
});
export const getTokenContract = (endPoint, tokenContractAddress) => __awaiter(void 0, void 0, void 0, function* () {
    return yield getContract(endPoint, tokenContractAddress);
});
export const getBalance = (tokenContract, symbol, owner) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield tokenContract.GetBalance.call({
        symbol,
        owner,
    });
    return result === null || result === void 0 ? void 0 : result.balance;
});
export const getAllowance = (tokenContract, symbol, owner, spender) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield tokenContract.GetAllowance.call({
        symbol,
        owner,
        spender,
    });
    return result === null || result === void 0 ? void 0 : result.allowance;
});
export const getTokenInfo = (tokenContract, symbol) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield tokenContract.GetTokenInfo.call({
        symbol,
    });
    if (!result.symbol)
        throw new Error(CONTRACT_GET_DATA_ERROR);
    return result;
});
export const approveAllowance = ({ tokenContractCallSendMethod, tokenContractAddress, endPoint, symbol, amount, spender, memo, }) => __awaiter(void 0, void 0, void 0, function* () {
    const approveResult = yield tokenContractCallSendMethod({
        contractAddress: tokenContractAddress,
        methodName: CONTRACT_METHOD_NAME.Approve,
        args: {
            spender,
            symbol,
            amount: amount.toString(),
            memo,
        },
    });
    if (!(approveResult === null || approveResult === void 0 ? void 0 : approveResult.transactionId))
        throw new Error('Missing transactionId');
    const txRes = yield getTxResult(approveResult.transactionId, endPoint);
    console.log('approveResult: ', approveResult, txRes);
    return true;
});
export const checkTokenAllowanceAndApprove = ({ tokenContractCallSendMethod, tokenContractAddress, endPoint, symbol, amount, owner, spender, memo, }) => __awaiter(void 0, void 0, void 0, function* () {
    const tokenContractOrigin = yield getTokenContract(endPoint, tokenContractAddress);
    const [allowance, tokenInfo] = yield Promise.all([
        getAllowance(tokenContractOrigin, symbol, owner, spender),
        getTokenInfo(tokenContractOrigin, symbol),
    ]);
    console.log('>>>>>> allowance', allowance);
    console.log('>>>>>> tokenInfo', tokenInfo);
    const bigA = timesDecimals(amount, (tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals) || 8);
    const allowanceBN = new BigNumber(allowance);
    if (allowanceBN.lt(bigA)) {
        yield approveAllowance({
            tokenContractCallSendMethod,
            tokenContractAddress,
            endPoint,
            symbol,
            amount: bigA.toFixed(0),
            spender,
            memo,
        });
        const allowanceNew = yield getAllowance(tokenContractOrigin, symbol, owner, spender);
        console.log('>>>>>> allowanceNew', allowanceNew);
        console.log('second check allowance:', allowanceNew);
        return bigA.lte(allowanceNew);
    }
    return true;
});
export const checkIsEnoughAllowance = ({ endPoint, tokenContractAddress, symbol, owner, spender, amount, }) => __awaiter(void 0, void 0, void 0, function* () {
    const tokenContractOrigin = yield getTokenContract(endPoint, tokenContractAddress);
    const [allowance, tokenInfo] = yield Promise.all([
        getAllowance(tokenContractOrigin, symbol, owner, spender),
        getTokenInfo(tokenContractOrigin, symbol),
    ]);
    console.log('>>>>>> allowance', allowance);
    console.log('>>>>>> tokenInfo', tokenInfo);
    const bigA = timesDecimals(amount, (tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals) || 8);
    const allowanceBN = new BigNumber(allowance);
    if (allowanceBN.lt(bigA)) {
        return false;
    }
    return true;
});
export const createManagerForwardCall = ({ caContractAddress, contractAddress, endPoint, args, methodName, caHash, chainId, }) => __awaiter(void 0, void 0, void 0, function* () {
    let instance, res, methods;
    instance = aelfInstance.getInstance(chainId, endPoint);
    res = yield handleManagerForwardCall({
        paramsOption: {
            contractAddress,
            methodName,
            args,
            caHash,
        },
        functionName: MANAGER_FORWARD_CALL,
        instance,
    });
    res.args = Buffer.from(AElf.utils.uint8ArrayToHex(res.args), 'hex').toString('base64');
    methods = yield getContractMethods(instance, caContractAddress);
    const protoInputType = methods[MANAGER_FORWARD_CALL];
    let input = AElf.utils.transform.transformMapToArray(protoInputType, res);
    input = AElf.utils.transform.transform(protoInputType, input, AElf.utils.transform.INPUT_TRANSFORMERS);
    const message = protoInputType.fromObject(input);
    return protoInputType.encode(message).finish();
});
export const createTransferToken = ({ contractAddress, chainId, endPoint, args }) => __awaiter(void 0, void 0, void 0, function* () {
    let instance, methods;
    instance = aelfInstance.getInstance(chainId, endPoint);
    methods = yield getContractMethods(instance, contractAddress);
    const protoInputType = methods[CONTRACT_METHOD_NAME.TransferToken];
    let input = AElf.utils.transform.transformMapToArray(protoInputType, args);
    input = AElf.utils.transform.transform(protoInputType, input, AElf.utils.transform.INPUT_TRANSFORMERS);
    const message = protoInputType.fromObject(input);
    return protoInputType.encode(message).finish();
});
export const handleTransaction = ({ blockHeightInput, blockHashInput, packedInput, address, contractAddress, functionName, getSignature, }) => __awaiter(void 0, void 0, void 0, function* () {
    // Create transaction
    const rawTx = getRawTx({
        blockHeightInput,
        blockHashInput,
        packedInput,
        address,
        contractAddress,
        functionName,
    });
    rawTx.params = Buffer.from(rawTx.params, 'hex');
    const ser = AElf.pbUtils.Transaction.encode(rawTx).finish();
    const signatureRes = yield getSignature(ser);
    const signatureStr = (signatureRes === null || signatureRes === void 0 ? void 0 : signatureRes.signature) || '';
    if (!signatureStr)
        return;
    let tx = Object.assign(Object.assign({}, rawTx), { signature: Buffer.from(signatureStr, 'hex') });
    tx = AElf.pbUtils.Transaction.encode(tx).finish();
    if (tx instanceof Buffer) {
        return tx.toString('hex');
    }
    return AElf.utils.uint8ArrayToHex(tx); // hex params
});
